import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import SuperSelect from "../../Misc/SuperSelect";

export default class ElementSpareEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      notFound: false,
      pending: false,
      types: [],
      item: {},
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.elementId !== this.props.elementId ||
      prevProps.itemId !== this.props.itemId
    ) {
      this.load();
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let types = await this.context.api.qa(`/demand/type`);
    this.setState({
      types,
      pending: false,
    });
  };

  load = async () => {
    const { elementId, itemId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (itemId) {
      let item = await this.context.api.q("/demand/get", { id: itemId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        this.setState({ item });
      }
    } else {
      let item = this.props.defaultValues;
      this.setState({ item });
    }
    this.setState({ pending: false });
  };

  save = async () => {
    const { elementId, itemId } = this.props;
    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: itemId || null,
      element: elementId,
      model: item.model,
      measure: item.measure,
      volume: item.volume,
      type: this.context.getType(item.typecode),
    };
    let result = await this.context.api.q("/demand/set", saveData);
    this.setState({ pending: false });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      if (this.props.onAfterSave) {
        this.props.onAfterSave(result);
      }
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  render() {
    const { pending, item, types } = this.state;
    const { itemId, manageModel, manageMeasure } = this.props;
    return (
      <>
        <Modal size="lg" show onHide={this.props.onHide}>
          <Modal.Header closeButton>
            <Modal.Title className="w-100">
              {!itemId ? "Добавление" : "Редактирование"} запчасти
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={pending} solid>
              <div className="form-group ">
                <label>Тип</label>
                <select
                  id="type"
                  value={item.typecode}
                  onChange={(e) => this.onChange("typecode", e.target.value)}
                  className="form-control"
                >
                  <option value=""></option>
                  {types.map((type) => (
                    <option value={type.code} key={type.code}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group  ">
                <label>ЗИП</label>
                <SuperSelect
                  add
                  async
                  searchByExtraFields
                  reclimit={50}
                  defaultValue={item.model}
                  onChange={(value) => this.onChange("model", value)}
                  essence="model"
                  placeholder="Выберите ЗИП..."
                  nameField="name"
                  idField="id"
                  extraFields={["code", "description"]}
                />
              </div>
              <div className="form-group">
                <label>Количество</label>
                <input
                  id="volume"
                  value={item.volume || ""}
                  onChange={(e) => this.onChange("volume", e.target.value)}
                  type="number"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Единица измерения</label>
                <SuperSelect
                  add
                  defaultValue={item.measure}
                  onChange={(value) => this.onChange("measure", value)}
                  essence="measure"
                  placeholder="Выберите единицу измерения..."
                  nameField="name"
                  idField="id"
                  reference={{
                    title: "Единицы измерения",
                    essence: "measure",
                    showDescription: true,
                    showType: true,
                  }}
                />
              </div>
            </Blocker>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={this.save} className="btn btn-primary mr-2">
              Сохранить
            </button>
            <button onClick={this.props.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
